import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { InView } from 'react-intersection-observer';
import classNames from 'classnames';

import { useSectionNavigation } from '@spotahome/ui-library/src/tenant/context/SectionNavigationContext';

import './ListingItem.scss';

const ListingSectionObservable = ({ section, children, className = null }) => {
  const { handleInView, height: offset } = useSectionNavigation();
  const [isSubscribed, setIsSubscribed] = useState(false);
  const wrapperRef = useRef(null);

  const handleOnScroll = () => {
    if (wrapperRef.current) {
      const { top, bottom } = wrapperRef.current.getBoundingClientRect();
      const offsetPlusOne = offset + 1;

      if (
        Math.round(top) <= offsetPlusOne &&
        Math.round(bottom) >= offsetPlusOne
      ) {
        handleInView(section);
      }
    }
  };
  const sectionClassNames = classNames('listing-section', className);

  return (
    <div
      data-sticky-in-navigation={section}
      data-cy={section}
      className={sectionClassNames}
      ref={wrapperRef}
    >
      <InView
        onChange={inView => {
          if (inView && !isSubscribed) {
            document.addEventListener('scroll', handleOnScroll, true);
            setIsSubscribed(true);
          } else if (!inView) {
            document.removeEventListener('scroll', handleOnScroll, true);
            setIsSubscribed(false);
          }
        }}
        as="section"
      >
        {children}
      </InView>
    </div>
  );
};

ListingSectionObservable.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
    .isRequired,
  section: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default ListingSectionObservable;
